export { getAccommodationsPage } from "./getAccommodationsPage";
export { getAccommodationsPointPage } from "./getAccommodationsPointPage";
export { getCurrentAccommodationsPoint } from "./getCurrentAccommodationsPoint";
